export default __webpack_public_path__ + "static/media/Lumion logo - Brandlogos.net.0f267103.svg";